import type { BridgeAPI } from "app-base/bridge"
import { createBridgeInstaller, type BridgeExposureHost } from "app-base/web-shell/bridge"
import {
  connectNativeBridge,
  type AndroidBridgeManifestBridge,
  type AppleBridgeManifestBridge,
  type NativeBridgeConnection,
  type WindowsBridgeManifestBridge,
} from "../Types/Generated/Bridge/NativeBridge"

const bridgeInstaller = createBridgeInstaller({
  connect: () => connectNativeBridge(window),
  host: window as unknown as BridgeExposureHost,
});

export function installBridge(host: Window = window): NativeBridgeConnection {
  if (host === window) {
    return bridgeInstaller.install();
  }
  return createBridgeInstaller({
    connect: () => connectNativeBridge(host),
    host: host as unknown as BridgeExposureHost,
  }).install();
}

export function appleBridge(): AppleBridgeManifestBridge | undefined {
  return bridgeInstaller.manifest("logbook.apple") as AppleBridgeManifestBridge | undefined;
}

export function androidBridge(): AndroidBridgeManifestBridge | undefined {
  return bridgeInstaller.manifest("logbook.android.next") as AndroidBridgeManifestBridge | undefined;
}

export function windowsBridge(): WindowsBridgeManifestBridge | undefined {
  return bridgeInstaller.manifest("logbook.windows.next") as WindowsBridgeManifestBridge | undefined;
}

export function bridgeFor(
  name: string,
  host: { ab?: BridgeAPI } = globalThis as unknown as { ab?: BridgeAPI },
): BridgeAPI | undefined {
  if (
    host === globalThis
    && bridgeInstaller.current()?.kind === "manifest"
  ) {
    return undefined;
  }
  const bridge = host.ab;
  return bridge?.supports(name) ? bridge : undefined;
}
